define((require) => {
    "use strict";

    const {defaults, extend, omit} = require("underscore");
    const Backbone                 = require("backbone");
    const ButtonIconModel          = require("shared/ui/experience/widgets/button/ButtonIconModel");
    const ButtonType               = require("shared/ui/experience/widgets/button/ButtonType");
    const WidgetScaleMode          = require("shared/ui/experience/widgets/WidgetScaleMode");
    const AbstractWidgetModel      = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const BUTTON_DEFAULTS = {
        type: "button",

        buttonType: ButtonType.TEXT_AND_ICON,

        label: "Button",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: "400",
        color: "#ffffff",
        fontFamily: "Arial",
        fontProvider: "standard",
        fontMetadata: {},

        padding: 12,

        backgroundColor: "#9b9b9b",
        borderColor: null,
        borderWidth: null,
        radius: 16,

        icon: null // when dragging in, this is set in WidgetTypesEditorMixin
    };

    const buttonWidgetDefaults = defaults({
        scaleMode: WidgetScaleMode.STRETCH
    }, BUTTON_DEFAULTS, AbstractWidgetModel.prototype.defaults);

    /**
     *
     * @class AbstractWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("ButtonWidgetModel", {

        relations: AbstractWidgetModel.prototype.relations.concat([{
            type: Backbone.One,
            key: "icon",
            relatedModel: ButtonIconModel
        }]),

        defaults: () => extend(buttonWidgetDefaults),

        // HACK: This line is needed for widgets supporting opacity. Remove
        // this (and the computed 'opacity' property in AbstractWidgetModel) once
        // we're comfortable... (see MOS-2375)
        computed: omit(AbstractWidgetModel.prototype.computed, "opacity"),

        fitToScene() {}
    }, {
        ButtonType,

        buttonDefaults: BUTTON_DEFAULTS
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/button/ButtonWidgetModel.js